import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from '..';
import { UserState } from './user.reducer';

export const getLoggedInUser = createFeatureSelector<AppState, UserState>('user');

export const getLoggedInUserRole = createSelector(getLoggedInUser, (userState: UserState) => userState.role);
